var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect } from "react";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";
import { TableContext, useTableContext } from './TableContext';
import { CustomCheckbox } from "../CustomCheckbox";
export var Table = function (_a) {
    var columns = _a.columns, data = _a.data, className = _a.className, _b = _a.id, id = _b === void 0 ? "default_table" : _b, _c = _a.checkboxConfig, checkboxConfig = _c === void 0 ? { enable: false } : _c, _d = _a.rearrangeConfig, rearrangeConfig = _d === void 0 ? { enable: false } : _d;
    var tableCtx = useTableContext(checkboxConfig);
    var updateSelectAll = function (length) {
        var select = data.length === length && data.length !== 0 ? true : false;
        tableCtx.setSelectAll(select);
    };
    /**
     * populates back the selected row ids to the DataTable's parent componnet
     */
    useEffect(function () {
        if (checkboxConfig.enable) {
            checkboxConfig.setSelectedRowIds(tableCtx.selectedRowIds);
        }
        updateSelectAll(tableCtx.selectedRowIds.length);
    }, [tableCtx.selectedRowIds]);
    var getCheckboxColumnConfig = function () {
        if (checkboxConfig.enable) {
            var rowIds_1 = data.map(function (r) { return r[checkboxConfig.uniqueId]; });
            return {
                id: checkboxConfig.uniqueId,
                style: { width: checkboxConfig.width + "px" || "53px" },
                label: (React.createElement(CustomCheckbox, { grey: true, checked: tableCtx.selectAll, onChange: function (e) { return tableCtx.handleSelectAll(e, rowIds_1); } })),
                fixed: true,
                tooltip: false,
                resizable: false,
                headerTooltip: false,
                align: "center",
                render: function (value, row, index) { return (React.createElement(CustomCheckbox, { grey: true, onChange: function (e) { return tableCtx.handleRowSelect(e, value); }, checked: tableCtx.selectedRowIds.includes(value) })); },
            };
        }
        return;
    };
    var checkboxColumnConfig = getCheckboxColumnConfig();
    var finalColumns = checkboxColumnConfig
        ? __spreadArray([checkboxColumnConfig], columns) : columns;
    return (React.createElement(TableContext.Provider, { value: tableCtx },
        React.createElement("table", { className: className },
            React.createElement(TableHeader, { columns: finalColumns }),
            React.createElement(TableBody, { tableId: id, data: data, columns: finalColumns, rearrangeConfig: rearrangeConfig }))));
};
